import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { mapObjIndexed, values } from 'ramda';

// Components
import Checkbox from '../../../Checkbox/Checkbox';

import cx from 'classnames';
import s from './Profile.css';
import { removeEmptyAriaOwns } from '../../../../lib/a11yUtils';

const AccessibleValue = ({ value }) => (
  <div className="Select-value" title={value.label}>
    <span className="Select-value-label">{value.label}</span>
  </div>
);

// @TODO if all (any) phone inputs are not set when creating a new Patient, they return null - prevent the following warning -
// proxyConsole.js:54 Warning: `value` prop on `input` should not be null. Consider using the empty string to clear the component or `undefined` for uncontrolled components.
class ContactInfo extends Component {
  componentDidMount() {
    removeEmptyAriaOwns(this.sectionRef);
  }

  componentDidUpdate() {
    removeEmptyAriaOwns(this.sectionRef);
  }

  render() {
    const { destinations, contactMethodOptions, labels, contactMethod, optOut, updateValue } = this.props;
    return (
  <section className={s.component} ref={el => this.sectionRef = el}>
    <h3 className={s.header}>
      Contact Information
    </h3>
    {values(mapObjIndexed((field, key) =>
      <div className={s.group} key={key}>
        <label
          className={s.label}
          name={`contactInfo__${key}`}
          htmlFor={`contactInfo__${key}`}
        >
          {labels[key]}
        </label>
        {key === "email" ?
          <div className={s.controlContainer}>
            <input
              id={`contactInfo__${key}`}
              className={s.control}
              type="email"
              value={field}
              placeholder="Type Email..."
              onChange={event => updateValue(key, event.target.value)}
            />
          </div>
        :
          <div className={s.controlContainer}>
            <input
              id={`contactInfo__${key}`}
              className={s.control}
              type="tel"
              value={field}
              placeholder={`Type ${labels[key]} ...`}
              onChange={event => updateValue(key, event.target.value)}
            />
          </div>
        }
      </div>, destinations)
    )}

    <div className={s.group}>
      <label
        id="contactMethodPreferred"
        className={s.label}
        htmlFor="contactMethodInput"
      >
        Preferred method of contact
      </label>
      <div className={s.controlContainer}>
        <Select
          id="contactMethod"
          aria-labelledby="contactMethodPreferred"
          searchable={false}
          clearable={false}
          value={contactMethod}
          options={contactMethodOptions}
          placeholder="Select Contact Method"
          className={cx(s.flex, "composeMessage")}
          optionClassName="composeMessage__option"
          onChange={val => updateValue("contactMethod", val.value)}
          inputProps={{id: 'contactMethodInput', 'aria-labelledby': 'contactMethodPreferred', 'aria-haspopup': 'listbox'}}
          valueComponent={AccessibleValue}
        />
      </div>
    </div>

    <div className={s.group}>
      <div className={s.controlContainer}>
        <Checkbox
          id="healthInfo"
          checked={!optOut}
          onChange={checked => updateValue("optOut", !checked)}
        >
          Send protected health information to my patient portal
        </Checkbox>
      </div>
    </div>
  </section>
    );
  }
}

ContactInfo.propTypes = {
  destinations: PropTypes.object,
  contactMethodOptions: PropTypes.array,
  labels: PropTypes.object,
  contactMethod: PropTypes.object,
  optOut: PropTypes.bool,
  updateValue: PropTypes.func,
};

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/Profile/ContactInfo.js